'use client';

import cn from 'classnames';
import { type ComponentProps, forwardRef } from 'react';

import './variant-base-button.scss';

type VariantBaseButtonProps = Omit<ComponentProps<'input'>, 'type' | 'checked' | 'className' | 'children'> & {
    name: string;
    label: string;
    value: string;
    isChecked: boolean;
    isUnavailable?: boolean;
};

export const VariantBaseButton = forwardRef<HTMLInputElement, VariantBaseButtonProps>(
    ({ name, label, value, isChecked, isUnavailable = false, ...rest }, ref) => {
        return (
            <label
                className={cn('variant-base__label', { selected: isChecked, unavailable: isUnavailable })}
                data-testid={`variant-base-${name}-${value.toLowerCase()}`}
            >
                <span className="variant-base__label-text">{label}</span>
                <input
                    ref={ref}
                    {...rest}
                    name={name}
                    type="radio"
                    value={value}
                    checked={isChecked}
                    className="variant-base__radio-input"
                />
            </label>
        );
    }
);

VariantBaseButton.displayName = 'VariantBaseButton';
